var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotissiaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 142.39 119.57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14.18 119.57q-6.91 0-10.55-3.79t-3.63-10.72v-90.06q0-7.09 3.63-11a12.55 12.55 0 0 1 9.73-4 14 14 0 0 1 8.08 2.06 33 33 0 0 1 6.56 6.68l52.32 65.31h-4.62v-59.7q0-6.76 3.55-10.56t10.47-3.79q6.93 0 10.55 3.79t3.63 10.56v91.37a14.63 14.63 0 0 1 -3.38 10 11.32 11.32 0 0 1 -9 3.88q-5.61 0-8.82-2.06a32 32 0 0 1 -7-6.68l-52.12-65.51h4.62v59.71q0 6.91-3.54 10.72t-10.48 3.79z",
    fill: "#0e7c86"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m126.39 119.57q-7.58 0-12-4.54a15.91 15.91 0 0 1 -4.45-11.62 15.16 15.16 0 0 1 4.45-11.3q4.45-4.36 12-4.37t11.8 4.37a15.63 15.63 0 0 1 4.2 11.3 16.41 16.41 0 0 1 -4.2 11.62q-4.19 4.55-11.8 4.54z",
    fill: "#93c3cd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotissiaLogo);
export default __webpack_public_path__ + "static/media/notissia-logo.b6864da81fa929235e22fdf44e177157.svg";
export { ForwardRef as ReactComponent };